/** @import modules */

import { useTranslation     } from "react-i18next";

import { useQuery }         from "@apollo/client";

/** @import queries */

import { LEGAL_DATA }       from "../../../../Queries/Contacts";

/**
 *
 * @returns Mobile navigation contacts component
 *
 */

const MobileNavContacts = () => { const { t } = useTranslation (),

    { data, loading } = useQuery(LEGAL_DATA, {
        variables: { countryCode: null }
    });

    /** @returns */

    return (<div className="contacts">

        <a href={ ( loading ) ? "/" : `tel:${ data.legalData.phone }` }>

            { t ( "call" ) } { ( loading ) ? `${ t ( "loading" ) }...` : data.legalData.phone }

        </a>

    </div>);
    
}

/** @export MobileNavContacts */
 
export default MobileNavContacts;